import {chain} from 'lodash';
import {createSelector} from 'reselect';

import {AppState} from '../../appState';

export function getLenses(state: AppState) {
  return state.data.lenses;
}

/** Get a flat list of all inboxes, sorted by name. */
export const getFlatLenses = createSelector(getLenses, (lenses) =>
  chain(lenses)
    .values()
    .compact()
    .sortBy((lens) => lens.name.toLowerCase())
    .value(),
);
